<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/new-course-history/${inputs.id}`
						: `transaction/new-course-history`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_new_course_id" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_new_course_id"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_new_course_id"
						@input="setCourseIdValue"
						fetch-url="transaction/new-course"
						class="col-sm-9"
						placeholder="Class Name"
						list-value-field="course_name"
						required
					/>
				</div>
			
				<div class="form-group row align-items-center">
					<label for="inputs_sub_status" class="col-sm-3 mb-0">
						Sub Status
					</label>
					<app-input
						id="inputs_sub_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_sub_status"
						@input="setSubStatusValue"
						:fetch-url="`/master/lead-status?lead_status_id=3&per_page=50`"
						:placeholder="'Sub Status'"
						list-value-field="status"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "NewClassTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			subStatusLists: [],
			input_new_course_id: this.value
				? this.value.new_course
					? {
							id: this.value.new_course.id || 0,
							course_name: this.value.new_course.course_name || "",
							is_active: this.value.new_course.is_active,
					  }
					: {
							id: this.value.new_course?.id || 0,
							course_name: this.value.new_course?.course_name || "",
							is_active: this.value.new_course?.is_active,
					  }
				: {
						id: this.value.new_course.id || 0,
						course_name: this.value.new_course.course_name || "",
						is_active: this.value.new_course.is_active,
				  },
			input_sub_status: this.value
				? this.value.sub_status
					? {
							id: this.value.sub_status.id || 0,
							status: this.value.sub_status.status || "",
					  }
					: {
							id: this.value.sub_status?.id || 0,
							status: this.value.sub_status?.status || "",
					  }
				: {
						id: this.value.sub_status.id || 0,
						status: this.value.sub_status.status || "",
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [subStatusResponse] = await Promise.all([
					axios.get(
						"/master/lead-status?lead_status_id=3&per_page=100"
					),
				]);

				subStatusResponse.data.data.forEach((item) => {
					this.subStatusLists.push({
						id: item.id,
						value: item.status,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs.id = response.data.id;
			this.input_sub_status = {
				id: this.inputs.sub_status_id?.id || 0,
				status: this.inputs.sub_status_id?.status || "",
			};
			this.input_new_course_id = {
				id: response.data.new_course_id?.id,
				course_name: response.data.new_course_id?.course_name,
			};
			this.inputs.new_course_id = response.data.new_course_id?.id;
			this.preloader = false;
		},

		setCourseIdValue(data) {
			this.inputs.new_course_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.new_course_id = data.id;
			}
		},
		setSubStatusValue(data) {
			this.inputs.sub_status = this.inputs.sub_status;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.sub_status = data.id;
			}
		},
	},
};
</script>
